import { render, staticRenderFns } from "./DataProfileTab.vue?vue&type=template&id=7a1bbe30&scoped=true&"
import script from "./DataProfileTab.vue?vue&type=script&lang=js&"
export * from "./DataProfileTab.vue?vue&type=script&lang=js&"
import style0 from "./DataProfileTab.vue?vue&type=style&index=0&id=7a1bbe30&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1bbe30",
  null
  
)

export default component.exports